import React, { Component } from 'react'
import { routerActions } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Header } from 'semantic-ui-react'
import AppHeader from '../components/AppHeader'
// import { Map, Marker } from '../components/Map';
import * as Events from '../store/Events'
import moment from 'moment'

class HomePage extends Component {
    componentWillMount() {
        const { actions } = this.props
        actions.getEvents()
    }
    render() {
        const { events } = this.props
        const uniqueCities = new Set(
            events
                .filter((e) => e.isPublished && e.isPublic)
                .filter((e) => moment().startOf('day') <= moment(e.start).endOf('day'))
                .map((e) => `${e.venue.city}`)
        )
        const cities = [...uniqueCities].map((city) => {
            return {
                id: city,
                events: events
                    .filter((e) => e.isPublished && e.isPublic)
                    .filter((e) => moment().startOf('day') <= moment(e.start).endOf('day'))
                    .filter((e) => e.venue.city === city),
            }
        })
        return (
            <div className="app">
                <AppHeader />
                <div className="bigimage"></div>
                <Container>
                    <Header className="page title" as="h1" content="Welcome to Denison Parking" />
                    {/* {event ? <Map center={{ lat: parseFloat(event.venue.lat), lng: parseFloat(event.venue.lng) }} zoom={14}>
                        <Marker 
                            open
                            position = {{ lat: parseFloat(event.venue.lat), lng: parseFloat(event.venue.lng) }}
                            title={event.venue.name}
                            address={`${event.venue.address}, ${event.venue.city}, ${event.venue.state} ${event.venue.zip}`}
                            icon={`/img/bluemarker.png`} />
                        
                        {event.inventory.map((i, idx) => (
                            <Marker key={idx} 
                                position={{lat: parseFloat(i.facility.lat), lng: parseFloat(i.facility.lng)}}
                                title={i.facility.name}
                                address={`${i.facility.address}, ${i.facility.city}, ${i.facility.state} ${i.facility.zip}`}
                            />))}
                    </Map> : event} */}
                    <Header as="h1" style={{ color: '#074c75' }}>
                        Upcoming Events
                    </Header>
                    {!cities.length ? <p style={{ color: '#666' }}>No Upcoming events</p> : null}
                    {cities.map((i, idx) => (
                        <div style={{ marginTop: 15 }}>
                            <Header as="h2">{i.id}</Header>
                            {i.events.map((e, idx) => (
                                <p>
                                    <a href={`/${e.slug}`}>
                                        {e.name} - {e.venue.name}
                                    </a>
                                </p>
                            ))}
                        </div>
                    ))}

                    <Header as="h1" style={{ color: '#07rc75' }}>
                        Contact Us
                    </Header>
                    <div>Denison Parking</div>
                    <div>
                        P. <a href="tel:317-633-4003">317.633.4003</a>
                    </div>
                    <div>
                        E. <a href="mailto:indianapolis@denisonparking.com">indianapolis@denisonparking.com</a>
                    </div>
                    <div>
                        <a href="http://www.denisonparking.com">www.denisonparking.com</a>
                    </div>
                </Container>
            </div>
        )
    }
}

HomePage.propTypes = {}

const mapStateToProps = (state, ownProps) => {
    return {
        events: Object.values(Events.selector(state).events),
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomePage)
